<template>
  
    <div :class="bonus.id == today_id?'daily-bonu-item active active_1':'daily-bonu-item'" v-if="bonus.status == 2">
        <div class="title" v-if="bonus.id == today_id">{{ $t('to_day_uppercase') }}</div>
        <div class="daily-bonu-item-body">
            <div>{{ $t(`${bonus.desc}`) }}</div>
            <div class="gem">
                <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
            </div>
            <div>+{{ bonus.gem }}</div>
        </div>
        <!-- <div class="button test">
            <button class="btn btn-main-sm" @click = "claim">{{ $t('claim') }}</button>
        </div> -->
    </div>    
    <div :class="bonus.id == today_id?'daily-bonu-item active':'daily-bonu-item'" v-else-if="bonus.status == 1">
        <div class="title" v-if="bonus.id == today_id">{{ $t('to_day_uppercase') }}</div>
        <div class="daily-bonu-item-body">
            <!-- <div>{{ $t('day_uppercase') }} {{ bonus.id }}</div> -->
            <div>{{ $t(`${bonus.desc}`) }}</div>
            <div class="gem">
                <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
            </div>
            <div>+{{ bonus.gem }}</div>
        </div>
        <div class="button test">
            <button class="btn btn-main-sm" @click = "claim">{{ $t('claim') }}</button>
            <!-- <img v-else src="/themes/ito/images/icon-check-bonus.svg" alt=""> -->
        </div>
    </div>    
    <div :class="bonus.desc == 'day_7'?'daily-bonu-item feature day_7':'daily-bonu-item feature'" v-else>
        <div class="title" v-if="bonus.id == today_id">{{ $t('to_day_uppercase') }}</div>
        <div class="daily-bonu-item-body">
            <div>{{ $t(`${bonus.desc}`) }}</div>
            <div class="gem">
                <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
            </div>
            <div>+{{ bonus.gem }}</div>
        </div>
    </div>    

</template>

<script>
    import {mapGetters} from 'vuex'
    import {claimDailyBonus} from "../../models/reward";
    import AppIcon from '@/components/common/AppIcon.vue';

    export default {
        name: "DailyBonusItem",
        components: { AppIcon },
        props: ['bonus', 'today_id'],

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return {
                    gem: 0
                }
            })
        },

        data() {
            return {};
        },

        created() {

        },

        methods: {
            claim() {
                const that = this;

                claimDailyBonus().then((response) => {

                    if (response.data.code != 0) {
                        return;
                    }

                    this.user_info.first_login = 0;

                    that.bonus.status = response.data.results.status || '';

                    const new_gem = response.data.results.update_gem || 0;
                    const gem = new_gem - that.user_info.gem;

                    that.user_info.gem = new_gem;

                    const gem_txt = gem > 0 ? '+' + gem : gem;

                    $('#congratulation_gem').text(gem_txt);
                    $('#getRewardedModal').modal();
                }).catch(({response}) => {
                    console.error(response);
                });
            }
        }
    }
</script>

<style scoped>
    .daily-bonu-item{
        position: relative;
    }
    .test{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
</style>
